import { render, staticRenderFns } from "./TabModalLimit.vue?vue&type=template&id=24f84ee4&"
import script from "./TabModalLimit.vue?vue&type=script&lang=js&"
export * from "./TabModalLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports